import { HOUR, MINUTE, SECOND } from "chat/imports/constants";

export const parseDuration = (durationInMilliseconds: number) => ({
  hours: Math.floor(durationInMilliseconds / HOUR),
  minutes: Math.floor((durationInMilliseconds % HOUR) / MINUTE),
  seconds: Math.floor((durationInMilliseconds % MINUTE) / SECOND),
});
